import Main from './SublicensingsMain'

const Sublicensings = {
  Main,
}

export default Sublicensings
